module.exports = __webpack_public_path__ + "static/media/rtreecontent.d835d502.PNG";